import { CallLogsPayload, updateTypeCallLogs } from "src/interfaces";
import { apiBaseUrl as baseUrl, fetch as http } from "./http";
import axios from "axios";
// export const fetchCallLogsService = async (page: number = 1) => {
//   try {
//     let query = `page=${page}`;
//     const url = `/call-logs?${query}`;
//     const data = await http.Get(url);
//     return data;
//   } catch (error: any) {
//     throw new Error(error);
//   }
// };

// export const fetchCallLogsService = async (filters: CallLogsPayload = {}) => {
//   try {
//     const queryParts: string[] = [];

//     Object.entries(filters).forEach(([key, value]) => {
//       if (value == null) return;

//       // Handle agentIds
//       if (key === "agentIds") {
//         if (Array.isArray(value) && value.length > 0) {
//           queryParts.push(`agentIds=${value.join(",")}`);
//         } else {
//           queryParts.push(`agentIds=`);
//         }
//         return;
//       }

//       if (value === "") {
//         queryParts.push(`${key}=`);
//         return;
//       }

//       queryParts.push(`${key}=${value}`);
//     });

//     const query = queryParts.join("&");
//     const url = `/call-logs?${query}`;

//     const response = await http.Get(url);

//     return response;
//   } catch (error) {
//     throw new Error("Failed to fetch call logs");
//   }
// };

export const fetchCallLogsService = async (filters: CallLogsPayload = {}) => {
  try {
    const queryParts: string[] = [];

    Object.entries(filters).forEach(([key, value]) => {
      if (key === "agent_ids") {
        if (Array.isArray(value) && value.length > 0) {
          queryParts.push(`agent_ids=[${value}]`);
        } else {
          queryParts.push(`agent_ids=[]`);
        }
        return;
      }
      if (value !== null && value !== undefined) {
        queryParts.push(`${key}=${encodeURIComponent(String(value))}`);
      }
    });

    const query = queryParts.join("&");
    const url = `/call-logs?${query}`;

    return await http.Get(url);
  } catch (error) {
    throw new Error("Failed to fetch call logs");
  }
};

export const fetchIvrMenusService = async () => {
  try {
    const url = `/ivr-menus`;
    const data = await http.Get(url);
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const fetchSyncIvrMenusService = async () => {
  try {
    const url = `/sync-ivr-menus`;
    const data = await http.Get(url);
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const fetchSyncExtensionsService = async () => {
  try {
    const url = `/sync-extensions`;
    const data = await http.Get(url);
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const fetchCustomerInfoService = async (payload: string | number) => {
  try {
    const url = `${baseUrl}/fetch-customer-info/${payload}`;
    const data = await axios.get(url);
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const fetchCallDetailService = async (sessionId: string | number) => {
  try {
    const url = `/call-detail/${sessionId}`;
    const response = await http.Get(url);
    return response;
  } catch (error: any) {
    throw new Error("Failed to fetch call detail");
  }
};

export const updateCallLogService = async (
  sessionId: string | number,
  payload: updateTypeCallLogs,
) => {
  try {
    const url = `/call-update/${sessionId}`;
    const response = await http.Post(url, payload);
    return response;
  } catch (error: any) {
    throw new Error("Failed to update call log");
  }
};
export const fetchQueueCallsService = async (page: number = 1) => {
  try {
    let query = `page=${page}`;
    const url = `/queue-calls?${query}`;
    const response = await http.Get(url);
    return response;
  } catch (error: any) {
    throw new Error("Failed to fetch call queue");
  }
};

export const fetchCallStatsService = async () => {
  try {
    const url = `/call-stats`;
    const response = await http.Get(url);
    return response;
  } catch (error: any) {
    throw new Error("Failed to fetch call stats");
  }
};

export const fetchCallLogsDetailsService = async (
  sessionId: string | number,
  page: number = 1,
) => {
  try {
    const url = `/call-detail-with-logs/${sessionId}?page=${page}`;
    const response = await http.Get(url);
    return response;
  } catch (error) {
    throw new Error("Failed to fetch call detail");
  }
};

export const exportCallLogsService = async (filters: any = {}) => {
  try {
    const queryParts: string[] = [];

    Object.entries(filters).forEach(([key, value]) => {
      if (key === "agent_ids") {
        if (Array.isArray(value) && value.length > 0) {
          queryParts.push(`agent_ids=[${value}]`);
        } else {
          queryParts.push(`agent_ids=[]`);
        }
        return;
      }
      if (value !== null && value !== undefined) {
        queryParts.push(`${key}=${encodeURIComponent(String(value))}`);
      }
    });

    const query = queryParts.join("&");
    const url = `/export-logs?${query}`;

    // The export endpoint returns a JSON payload with a download_url
    // use normal GET to parse JSON instead of ExportGet which returns a blob
    return await http.Get(url);
  } catch (error) {
    throw new Error("Failed to export call logs");
  }
};

export const fetchCallLogsExtensionService = async () => {
  try {
    const url = `/get-extensions`;
    const response = await http.Get(url);
    return response;
  } catch (error) {
    throw new Error("Failed to fetch calllogs extension");
  }
};
